import React from 'react';
import classNames from 'classnames';
import { RichText } from '@graphcms/rich-text-react-renderer';
import { RichTextContent } from '@graphcms/rich-text-types';

export interface HeaderBannerProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  subtitle?: string | null;
  mobileSubTitle?: string | null;
  mobileTitle?: string | null;
  buttonOnClick?: () => void;
  actionText?: string;
  desktopImage: string;
  mobileImage: string;
  gif?: string | null;
  terms?: string | null;
}

export const HeaderBanner = ({
  buttonOnClick,
  actionText,
  desktopImage,
  mobileImage,
  gif,
  title,
  subtitle,
  mobileTitle,
  mobileSubTitle,
  terms,
  ...rest
}: HeaderBannerProps) => {
  return (
    <div className="min-w-full snap-start" {...rest}>
      <div className="w-full h-full relative flex flex-col">
        <picture className="min-h-[300px] h-full block">
          <source
            className="object-cover w-full h-full"
            media="(max-width: 860px)"
            srcSet={mobileImage}
          />
          <img className="object-cover w-full h-full" alt="banner_image" src={desktopImage} />
        </picture>
        {terms && (
          <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-x-0 bottom-0
                     h-1/3 md:h-1/6 bg-gradient-to-b from-white/0 via-[rgb(0,38,43)]/70 to-[rgb(0,38,43)]"
          />
        )}

        <div className="flex absolute inset-0">
          <div className="absolute inset-y-0 flex flex-col justify-center px-4 lg:pl-[12%] w-full ">
            <div className="flex-grow flex flex-col justify-center">
              <h3 className="!whitespace-pre-wrap hidden max-w-[650px] lg:block m-0 text-white text-[27px]">
                {title}
              </h3>
              <h4 className="!whitespace-pre-wrap max-w-[50%] m-0 text-base lg:hidden text-white">
                {mobileTitle ? mobileTitle : title}
              </h4>
              {subtitle && (
                <div className="whitespace-pre-wrap hidden lg:block m-0 mt-4 text-white leading-tight">
                  {subtitle}
                </div>
              )}
              {(subtitle || mobileSubTitle) && (
                <div className="whitespace-pre-wrap lg:hidden m-0 mt-4 text-[12px] text-white leading-tight">
                  {mobileSubTitle ? mobileSubTitle : subtitle}
                </div>
              )}
              {buttonOnClick && actionText && (
                <button
                  onClick={buttonOnClick}
                  className={classNames(
                    'mt-3 lg:mt-8 px-2 py-1.5 bg-black/40 rounded-lg backdrop-blur-lg border-[1px] border-gray-400 text-white font-bold w-fit',
                    'text-sm lg:text-base',
                    'ease-in-out transition-all duration-200 active:scale-[98%] hover:scale-[102%]',
                  )}
                  type="button"
                >
                  {actionText}
                </button>
              )}
            </div>
            {terms && (
              <div className="relative justify-start flex flex-col pb-1 mt-4 text-xs text-white [&_a]:underline [&_p]:m-0 [&_p]:p-0">
                <RichText content={terms as unknown as RichTextContent} />
              </div>
            )}
          </div>
          {gif && (
            <div className="w-full flex justify-end items-center lg:pr-[6%]">
              <img className="h-full object-fit" alt="banner_gif" srcSet={gif} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
